// Activity feed helper — writes a friendly row into activity_log.
import { supabase } from "@/lib/supabase";

export async function logActivity({ organization_id, actor_user_id, client_id = null, action, summary, entity_type = null, entity_id = null }) {
  try {
    await supabase.from("activity_log").insert({
      organization_id, actor_user_id, client_id, action, summary, entity_type, entity_id,
    });
  } catch (e) {
    // Non-fatal
    console.warn("activity log failed", e);
  }
}
